export default __webpack_public_path__ + "static/media/sh-reply-active.fc0d50ca.svg";